export const SCHOOL_HERO_COPY = {
  eyebrow: 'DUBAI FITNESS CHALLENGE 2026',
  title: 'VILLAGE VISITS & ENGAGEMENT PROGRAMME',
  subtitle: 'Visit a DFC 30x30 Fitness Villages with your students',
  cta: 'BOOK NOW',
} as const;

/** Shown on the sign-in / sign-up tabs so schools don't try their DFC credentials. */
export const SCHOOL_REGISTRATION_NOTICE =
  'Please register to this platform to complete your booking. Please note this is a new registration separate to the DFC log in.';
